import { type AppDispatch } from "features/Application/globaltypes/redux";
import { errPurchasePrice, gotPurchasePrice, reqPurchasePrice } from "../slices/purchasePriceSlice";
import packsDataService from "../../../services/packsDataService";
import { type BillingInfo, type PaymentPack } from "../../types";

export const fetchPurchasePrice = (packs: PaymentPack[], billingInfo: BillingInfo) => async (dispatch: AppDispatch) => {
  const params = {
    packLicenses: packs.map((p) => `${p.packId}:${p.licensesCount}`),
    addressLine1: billingInfo.streetAddress,
    city: billingInfo.city,
    state: billingInfo.state,
    zipCode: billingInfo.zipCode,
  };

  try {
    dispatch(reqPurchasePrice());
    const response = await packsDataService.getPurchasePrice(params);
    if ("errorMessage" in response.data) {
      dispatch(errPurchasePrice(response.data.errorMessage));
    } else {
      dispatch(gotPurchasePrice(response.data));
    }
  } catch (error) {
    dispatch(errPurchasePrice("Failed to get Purchase Price. Please try again."));
  }
};
